import {
  CollectionActions,
  CollectionStateSlice,
  mergeDocuments,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { transformUserContestCollaborationWhitelist } from './user-contest-collaboration-whitelist.transformers';
import { UserContestCollaborationWhitelistCollection } from './user-contest-collaboration-whitelist.types';

export function userContestCollaborationWhitelistReducer(
  state: CollectionStateSlice<UserContestCollaborationWhitelistCollection> = {},
  action: CollectionActions<UserContestCollaborationWhitelistCollection>,
) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'userContestCollaborationWhitelist') {
        const { result, ref, order } = action.payload;
        return mergeDocuments<UserContestCollaborationWhitelistCollection>(
          state,
          transformIntoDocuments(
            [result],
            transformUserContestCollaborationWhitelist,
            ref.path.authUid,
          ),
          order,
          ref,
        );
      }
      return state;
    }
    default:
      return state;
  }
}
